import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=d25864aa&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=d25864aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25864aa",
  null
  
)

export default component.exports